import {RELATIVES_API_URL} from "../../../shared/constants/api";

export const TIMELINE_URL = `${RELATIVES_API_URL}/timeline`;
